import React, { createContext, useState } from "react";

export const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
    const [headerState, setHeaderState] = useState(false);

    const updateState = (newState) => {
        setHeaderState(newState);
    };

    return (
        <HeaderContext.Provider value={{ headerState, updateState }}>
            {children}
        </HeaderContext.Provider>
    );
};
